module.exports = __webpack_public_path__ + "img/manda_019.add0ae70.png";